<template>
	<div class="section-how-it-work-slider">
		<div class="container">
			<v-layout row wrap justify-center id="como-funciona">
				<v-flex xs12 md5 secondary--text class="section-how-it-work-slider-title">
					<h3>¿Cómo funciona</h3>
					<h2>CASAMARKET?</h2>
				</v-flex>
				<v-flex xs12 md6 newaccent--text class="section-how-it-work-slider-subtext">
					<p>
						Te queremos mostrar lo sencillo que es usar CasaMarket; 
						prepárate para añadir a tu negocio una potente herramienta 
						de tecnología:
					</p>
				</v-flex>
			</v-layout>
			<div class="section-how-it-work-slider-steps">
				<v-layout>
					<v-flex 
						v-for="item in items" 
						:key="item.id">
						<button 
							class="container-step"
							:class="{ 'select' : item.number - 1 === sliderIndex}"
							@click="moveToIndex(item.number)">{{item.id}}</button>
					</v-flex>
				</v-layout>
				<hr class="section-how-it-work-slider-line">
			</div>
			<div class="container-sliders">
				<slider 
					animation="fade"
					:speed="2000"
					:stop-on-hover="true"
					:autoplay="false"
					:touch="false"
					height="100%"
					v-model="sliderIndex"
				>
					<slider-item v-for="item in items" :key="item.id">
						<v-layout wrap class="h-100">
							<v-flex md7 xs12 class="order-2-mobile">
								<div class="slider-image-container">
									<div class="slider-number">{{ item.number}}</div>
									<div class="container-phones" :class="{'big': item.big}">
										<img
											:src="item.step"
											alt="tu cliente realiza el pedido"
											height="592"
											class="step-image-cel"
											:class="{'big': item.big}"
										/>	
									</div>
								</div>
							</v-flex>
							<v-flex md5 xs12 class="layout order-1-mobile">
								<v-layout wrap align-content-end>
									<v-flex xs12 mb-3 class="container-image">
										<img 
											:src="item.image" 
											:alt="item.title"
											height="150"
											class="container-desktop">
									</v-flex>
									<v-flex xs12>
										<div class="layout container-information">
											<div class="step-number">{{ item.id }}</div>
											<div class="container-text">
												<h3 class="slider-title">{{ item.title }}</h3>
												<template v-if="item.text">
													<p
														class="step-text newaccent--text"
														:class="{ 'no-margin': item.list }"
													>
														{{ item.text }}
													</p>
												</template>
												<template v-if="item.list">
													<template v-for="(li, index) in item.list">
														<p
															:key="index"
															class="step-list info--text"
															:class="{ 'margin': li.list }"
														>
															- {{ li }}
														</p>
													</template>
												</template>
												<div class="mt-3 container-desktop">
													<a class="text-decoration-none" href="#banner-simulator">
														<v-btn
															class="btn-action btn-auto section-how-it-work-slider-btn white--text"
															color="primary"
															depressed
														>
															QUIERO VENDER
														</v-btn>
													</a>
												</div>
											</div>
										</div>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</slider-item>
				</slider>
			</div>
		</div>
	</div>
</template>

<script>

function moveToIndex(index) {
	this.sliderIndex = index - 1;
}

function data() {
	return {
		items: [
			{
				id: 1,
				class: 'step-image-1',
				image: '/static/images-new/sections/slider-1.png',
				number: 1,
				position: true,
				text: 'A través de nuestra web podrás registrarte de manera fácil y rápida.',
				title: 'Registrate en nuestra web',
				step: '/static/images-new/sections/step-1.png',
				big: false,
			},
			{
				id: 2,
				class: 'step-image-2',
				image: '/static/images-new/sections/slider-2.png',
				number: 2,
				position: false,
				text: 'A través de nuestra plataforma tus clientes podrán buscarte y hacer sus compras.',
				title: 'Tu marca aparecera en nuestra app',
				step: '/static/images-new/sections/step-3.png',
				big: false,
			},
			{
				id: 3,
				class: 'step-image-3',
				image: '/static/images-new/sections/slider-3.png',
				number: 3,
				position: true,
				title: 'Y LISTO A VENDER',
				text: 'Aparecerá tu logo y tus productos. Así tus clientes podrán realizar sus compras.',
				step: '/static/images-new/sections/step-2.png',
				big: true,
			},
		],
		sliderIndex: 0,
	};
}
export default {
	name: 'section-slider',
	data,
	methods: {
		moveToIndex,
	},
};
</script>

<style lang="scss">
	.section-how-it-work-slider {
		background-image: url('/static/images-new/banners/background-slider.svg');
		background-size: cover;
		padding: 90px 13%;
		font-size: size(medium16);
		text-align: center;

		&-title {
			line-height: 1;

			@media (min-width: 1024px) {
				border-right: 2px solid color(secondary);
				padding-right: 28px;
				text-align: right;
			}

			h3 {
				font-size: size(large30);
				font-weight: weight(w900);
				text-transform: uppercase;

				@media (max-width: 1024px) {
					font-size: size(large25);
				}
			}

			h2 {
				font-size: size(large47);
				font-weight: weight(w900);

				@media (max-width: 1024px) {
					font-size: size(large30);
				}
			}
		}

		&-subtext {
			p {
				font-size: size(medium18);
				line-height: 23px;
				margin: 47px auto 0px;
				max-width: 287px;

				@media (min-width: 1024px) {
					margin: 15px 0px 0px 38px;
					max-width: none;
					text-align: left;
				}
			}
		}

		&-steps {
			margin: 80px auto;
			position: relative;
			width: 70%;

			@media (max-width: 1024px) {
				display: none;
			}
		}

		&-line {
			border: 1px solid color(warning);
			left: 12%;
			position: absolute;
			top: 50%;
			width: 70%;
		}

		&-btn {
			border-radius: 8px;
			font-size: size(medium18);
			font-weight: weight(w600);
			height: 48px !important;
			width: 206px !important;
		}

		.container {
			&-step {
				align-items: center;
				background-color: color(white);
				border: 1px solid color(primary);
				border-radius: 50%;
				color: color(primary);
				display: flex;
				font-size: size(large37);
				font-weight: 600;
				justify-content: center;
				height: 98px;
				position: relative;
				margin: 0 auto;
				width: 98px;
				z-index: 1;

				&.select {
					border: none;
					background: color(newprimary);
					color: color(white);
				}
			}

			&-sliders {
				height: 510px;
				min-height: 510px;

				@media (max-width: 1024px) {
					height: 760px;
				}
			}
		}

		.slider-image-container {
			height: 100%;
			padding: 0 10%;
			position: relative;

			@media (max-width: 1024px) {
				padding: 0;
			}
		}

		.slider-number {
			color: rgba(255, 110, 28, 0.1);
			display: initial;
			font-size: 400px;
			font-weight: 900;
			left: 16%;
			line-height: 1.3;
			position: absolute;
			top: 0;
			z-index: 1;

			@media (max-width: 1024px) {
				display: none;
			}
		}

		.container-phones {
			margin-left: auto;
			position: relative;
			width: 284px;

			@media (max-width: 1024px) {
				margin: auto;
			}

			&.big {
				@media (min-width: 1024px) {
					width: auto;
				}
			}
		}

		.step-image-cel {
			height: 390px;
			max-width: 100%;

			&.big {
				height: auto;

				@media (min-width: 1024px) {
					transform: translateY(50%);
				}
			}

			@media (min-width: 1024px) {
				height: 510px;
			}
		}

		.step-image-gif {
			border-radius: 20px;
			left: 31px;
			position: absolute;
			top: 12px;
		}

		.slider-indicators-center {
			display: none;
		}

		.slider-btn {
			background: color(primary) !important;
			border-radius: 50%;
			height: 58px !important;
			top: 50% !important;
			width: 58px !important;

			@media (max-width: 1024px) {
				bottom: 0 !important;
				top: auto !important;
			}

			&.slider-btn-right {
				@media (max-width: 1024px) {
					right: 25% !important;
				}
			}

			&.slider-btn-left {
				@media (max-width: 1024px) {
					left: 25% !important;
				}
			}
		}

		.slider-icon {
			border-left: 4px solid color(white) !important;
			border-bottom: 4px solid color(white) !important;
		}

		.step-number {
			color: color(primary);
			font-size: size(large77);
			font-weight: 600;
			line-height: 0.8;

			@media (max-width: 1024px) {
				font-size: size(large60);
			}
		}

		.container-text {
			padding: 0 25px;
			text-align: left;

			@media (max-width: 1024px) {
				padding: 0 0 0 10px;
				width: 100%;
			}
		}

		.container-information {
			padding: 0 80px 0 10px;

			@media (max-width: 1024px) {
				padding: 0 0 0 10px;
			}
		}

		.slider-title {
			border-bottom: 3px solid color(newprimary);
			color: color(primary);
			font-size: size(large25);
			margin-bottom: 20px;

			@media (max-width: 1024px) {
				font-size: size(medium20);
			}
		}

		.container-image {
			padding: 0 80px 0 10px;

			@media (max-width: 1024px) {
				order: 1;
			}
		}

		.step-text {
			font-size: size(medium16);
			line-height: 1;
			margin-bottom: 65px;
			margin-top: 21px;
			text-align: left;

			&.no-margin {
				margin-bottom: 20px;
			}

			@media (max-width: 1024px) {
				margin-bottom: 15px;
				padding: 0 10px 0 0;
			}
		}

		.step-list {
			font-size: size(medium16);
			margin-bottom: 8px;
			text-align: left;

			&:last-of-type {
				&.margin {
					margin-bottom: 65px;
				}
			}

			@media (max-width: 1024px) {
				padding-right: 10px;
			}
		}

		@media (max-width: 1024px) {
			padding: 30px 0px;
		}

		.order-1-mobile {
			@media (max-width: 1024px) {
				order: 1;
			}
		}

		.order-2-mobile {
			@media (max-width: 1024px) {
				order: 2;
			}
		}

		.container-desktop {
			@media (max-width: 1024px) {
				display: none;
			}
		}

		.h-100 {
			height: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/section-slider.vue